import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnInit
} from '@angular/core';
import { DateTime } from 'luxon';
import { Subscription, from } from 'rxjs';
import { ApConfigFieldFriendlyNameMap } from 'src/app/interfaces/friendly-name-maps/ap-config-friendly-name-map';
import { SharedDataService } from 'src/app/services/shared-data.service';
import { apConfigsService } from 'src/app/shared/vive-api/ap-configs.service';
import { ApConfigDto } from 'src/app/shared/vive-api/vive-api-models';

@Component({
  selector: 'app-admin-client-ap-configs',
  templateUrl: './admin-client-ap-configs.component.html',
  styleUrl: './admin-client-ap-configs.component.less',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class AdminClientApConfigsComponent implements OnInit {
  constructor(
    private SharedDataService: SharedDataService,
    private ChangeDetectorRef: ChangeDetectorRef
  ) {
    this.SharedDataService.listenForEvent<number>().subscribe({
      next: ({ eventName, data }) => {
        if (eventName === 'SetCompanyId' && data) {
          this.CompanyId = data;

          from(
            apConfigsService.findAllForClient({
              pathParams: { companyId: this.CompanyId }
            })
          ).subscribe({
            next: ({ data: ApConfigs }) => {
              this.ApConfigs.push(...ApConfigs);
              this.ChangeDetectorRef.markForCheck();
            }
          });
        }
      }
    });

    this.SharedDataService.sendEvent('GetCompanyId');
  }

  CompanyId!: number;
  SharedDataServiceSubscription?: Subscription;

  ApConfigs: ApConfigDto[] = [];
  // Can migrate to forms in the future if need be.
  // ApConfigForms = new FormArray<ApConfigForm>([]);

  ApConfigFieldFriendlyNameMap: ApConfigFieldFriendlyNameMap = {
    apSystem: 'AP System',
    apDisplayName: 'AP Display Name',
    endpointUrl: 'URL',
    clientCode: 'Client Code',
    username: 'Username',
    allowAutolinks: 'Allow Auto Links?',
    syncInterval: 'Sync Interval?',
    isTwoWay: 'Two Way?',
    allowCreateVendors: 'Allow Vendors to be created in AP System?',
    allowPullSites: 'Allow Sites to be pulled in from AP System?',
    pushesActiveStatus: 'Push Active/Inactive Status?',
    pushesHold: 'Push Hold Payment for Non-Compliance?',
    pushesInsurance: 'Push Insurance Policies?',
    pushExpInsHold: 'Push Hold Payment for Expired Insurance?',
    allowVendorNameEdit: 'Allow Vendor Name / DBA to be updated in AP System?',
    allowVendorAddressEdit: 'Allow Vendor Address to be updated in AP System?',
    allowVendorContactEdit:
      'Allow Primary Vendor Contact to be updated in AP System?',
    allowVendorServiceTypeEdit:
      'Allow Service Type to be updated in AP System?',
    allowVendorEinEdit: 'Allow Vendor EIN/SSN to be updated in AP System?',
    allowVendor1099Edit: 'Allow 1099 Requirement to be updated in AP System?',
    showStatusChange: 'Show Status Change?',
    showExemptChange: 'Show Exempt Change?',
    isManualOnlySync: 'Manual Only Sync?',
    nextVendorSync: 'Next Sync?',
    lastVendorSync: 'Last Sync?',
    lastVendorSyncStatus: 'Last Sync Status',
    retryInterval: 'Retry Interval'
  };

  keyValuePairDefaultOrder(a: any, b: any): number {
    return 0;
  }

  formatValue(value: any) {
    if (typeof value === 'boolean') {
      return value ? 'Yes' : 'No';
    }

    if (value instanceof Date) {
      return DateTime.fromJSDate(value).toFormat('MM/dd/yyyy HH:mm:ss');
    }

    return value;
  }

  ngOnInit(): void {}
}
